export default "__VITE_ASSET__31400231__"